import Angular from "angular";
import Controller from "./new-booking-options.controller";
import Template from "./new-booking-options.html";
import Bookings from "../../services/bookings.service";
import Search from "../../components/search/search";
import BookingColorSelection from "../../components/booking-color-selection/booking-color-selection";
import BookingProcessorSelection from "../../components/booking-processor-selection/booking-processor-selection";
import CustomerDetails from "../../components/customer-details/customer-details";

export const NewBookingOptionsView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.new-booking-options', [
    Bookings.name,
    Search.name,
    BookingColorSelection.name,
    BookingProcessorSelection.name,
    CustomerDetails.name
]);



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-options/new-booking-options.js